<template>
    <div>
        <nav-bar/>
        <title-bar :title='$route.meta.title'/>
        <ul>
            <li v-for="item in $store.state.userInfo.fansUserIds">
                <!-- <img :src="" > -->
                <div>
                    <div></div>
                    <div></div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import  NavBar  from '@/components/NavBar.vue'
    import TitleBar from '@/components/TitleBar.vue'

    export default {
        components: {
            NavBar,
            TitleBar
        }
    }
</script>

<style scoped>

</style>